import styled from 'styled-components';
import PropTypes from 'prop-types';
import { COMMON, LAYOUT } from '../constants';
import setMaxWidth from './utils/setMaxWidth';
const Container = styled.div.withConfig({
  displayName: "Container",
  componentId: "sc-97b7uv-0"
})(["", ";", ";width:100%;", ";"], COMMON, LAYOUT, setMaxWidth);
Container.defaultProps = {
  mx: 'auto',
  px: 3
};
Container.propTypes = { ...COMMON.propTypes,
  ...LAYOUT.propTypes,
  fluid: PropTypes.bool
};
Container.displayName = 'Container';
export default Container;